import { render, staticRenderFns } from "./surrender.vue?vue&type=template&id=ff0c6822&scoped=true&"
import script from "./surrender.vue?vue&type=script&lang=js&"
export * from "./surrender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0c6822",
  null
  
)

export default component.exports